export class SystemSetting {
    constructor(
        public quantity: number = 0,
        public price: number = 0,
        public ratio: number = 0,
        public exchangeRate: number = 0,
        public amount: number = 0,
        public convertedAmount: number = 0,
        public number: number = 0,
    ) {
    }
}
